var exports = {
  "S": "xcc377c0b--2b82ad--image",
};

module.exports = exports;
